export const ownerData = {
  name: 'Md. Rahim Uddin',
  landOwnerId: 'LO-2026-000145',
  nid: '1987654321098',
  father: 'Abdul Karim',
  mother: 'Ayesha Begum',
  spouse: 'Salma Akter',
  mobile: '+8801712345678',
  address:
    'Village Boro Bari, Post Kaliganj, Upazila Kaliganj, District Gazipur',
  certificateNo: 'LOC-2026-14589',
  issueDate: '15 January 2026',
  validity: 'Active',
  photo: null, // use initials 'MR'
}

export const landsData = [
  {
    id: 'LAND-001',
    district: 'Gazipur',
    upazila: 'Kaliganj',
    mouza: 'Jamalpur',
    khatian: '1023',
    plot: '456',
    type: 'Agricultural',
    area: '45 decimals',
    ownership: 'Sole',
    mutation: 'Completed',
    tax: 'Paid',
    dispute: 'None',
  },
  {
    id: 'LAND-002',
    district: 'Gazipur',
    upazila: 'Kaliganj',
    mouza: 'Jamalpur',
    khatian: '1024',
    plot: '457',
    type: 'Residential',
    area: '12 decimals',
    ownership: 'Sole',
    mutation: 'Pending',
    tax: 'Due',
    dispute: 'None',
  },
  {
    id: 'LAND-003',
    district: 'Narsingdi',
    upazila: 'Shibpur',
    mouza: 'Putia',
    khatian: '887',
    plot: '1221',
    type: 'Commercial',
    area: '8 decimals',
    ownership: 'Joint',
    mutation: 'Completed',
    tax: 'Paid',
    dispute: 'Civil case under review',
  },
]

export const dashboardInsights = {
  totalLands: 3,
  totalArea: '65 decimals',
  districts: ['Gazipur', 'Narsingdi'],
  pendingServices: 2,
  unpaidTax: 1,
  activeNotices: 3,
}

export const notificationsData = [
  {
    id: 1,
    type: 'notice',
    title: 'Annual Land Tax Reminder',
    message: 'Land tax for LAND-002 is due. Please pay before 30 March 2026.',
    date: '01 March 2026',
    read: false,
  },
  {
    id: 2,
    type: 'mutation',
    title: 'Mutation Application Update',
    message:
      'Your mutation application for LAND-002 (Plot 457) is under review.',
    date: '25 February 2026',
    read: false,
  },
  {
    id: 3,
    type: 'dispute',
    title: 'Case Hearing Scheduled',
    message: 'Civil case for LAND-003 hearing scheduled on 20 March 2026.',
    date: '20 February 2026',
    read: false,
  },
  {
    id: 4,
    type: 'verification',
    title: 'Certificate Verified',
    message:
      'Your Land Owner Certificate was verified by Kaliganj Land Office.',
    date: '15 February 2026',
    read: true,
  },
  {
    id: 5,
    type: 'notice',
    title: 'System Maintenance Notice',
    message:
      'The portal will undergo maintenance on 10 March 2026 from 2AM-6AM.',
    date: '08 March 2026',
    read: true,
  },
]

export const servicesData = [
  {
    id: 'svc-1',
    name: 'Apply for Mutation',
    icon: 'FileTextIcon',
    description:
      'Transfer land ownership records after purchase or inheritance',
    status: 'available',
  },
  {
    id: 'svc-2',
    name: 'Apply for Correction',
    icon: 'EditIcon',
    description: 'Request correction in land records or certificate',
    status: 'available',
  },
  {
    id: 'svc-3',
    name: 'Inheritance Update',
    icon: 'UsersIcon',
    description: 'Update land records after inheritance',
    status: 'available',
  },
  {
    id: 'svc-4',
    name: 'Transfer Application',
    icon: 'ArrowRightLeftIcon',
    description: 'Apply for ownership transfer',
    status: 'available',
  },
  {
    id: 'svc-5',
    name: 'Pay Land Tax',
    icon: 'BanknoteIcon',
    description: 'Pay annual land development tax online',
    status: 'action_needed',
    count: 1,
  },
  {
    id: 'svc-6',
    name: 'Download Certificate',
    icon: 'DownloadIcon',
    description: 'Download your Land Owner Certificate',
    status: 'available',
  },
  {
    id: 'svc-7',
    name: 'Track Application',
    icon: 'SearchIcon',
    description: 'Track status of submitted applications',
    status: 'in_progress',
    count: 2,
  },
]
